import type { File } from '../file';
import type { Community } from './community';
import type { Quote } from './quote';
import type { RequestType, RequestTypes } from './request-type';
import type { Unit } from './unit';
import type { User } from './user';

export interface Request {
  id: string;
  summary: string;
  description: string;
  assigned_to_id: string;
  assigned_to?: User;
  created_by?: User;
  request_type_id: RequestTypes;
  request_type?: RequestType;
  unit_id: string | null;
  unit?: Unit;
  community_id: string;
  community?: Community;
  files?: File[];
  created_at: string;
  status_id: RequestStatuses;
  request_status?: RequestStatus;
  conversation_id: string;
  experienced_on: string | null;
  quotes?: Quote[];
  incident_date: string | null;
}

export interface RequestStatus {
  id: number;
  name: string;
  color: string;
  description: string;
  created_at: string;
  updated_at: string;
}

export const Request_Status = {
  1: 'New',
  2: 'Initial Review',
  3: 'Quoting',
  4: 'Quoted',
  5: 'Final Review',
  6: 'Approved',
  7: 'Rejected',
  8: 'Scheduled',
  9: 'Quality Review',
  10: 'Completed',
  NEW: 1,
  INITIAL_REVIEW: 2,
  QUOTING: 3,
  QUOTED: 4,
  FINAL_REVIEW: 5,
  APPROVED: 6,
  REJECTED: 7,
  SCHEDULED: 8,
  QUALITY_REVIEW: 9,
  COMPLETED: 10,
} as const;
export type RequestStatuses = keyof typeof Request_Status;
